<section class="profile-qr" aria-labelledby="profile-qr-title">
  <h2 id="profile-qr-title" class="profile-qr__title">{{ copy.TITLE }}</h2>

  @switch (state().status) {
    @case ('loading') {
      <div class="profile-qr__body">
        <div class="profile-qr__code profile-qr__code--skeleton" aria-busy="true"></div>
      </div>
    }

    @case ('ready') {
      @if (qrData(); as data) {
        <div class="profile-qr__body">
          <!--
            Fondo claro fijo (token de superficie): el lector necesita negro sobre blanco, con o sin tema.
            Nombre accesible en el contenedor (H2 de Astra): en la rama `svg`, angularx-qrcode no aplica `ariaLabel` ni
            `alt`, así que el gráfico es este `role="img"` y el SVG de dentro queda como presentacional.
          -->
          <div class="profile-qr__code" role="img" [attr.aria-label]="copy.ALT">
            <qrcode [qrdata]="data" [errorCorrectionLevel]="'M'" [elementType]="'svg'" [width]="240" [margin]="4" />
          </div>

          <div class="profile-qr__info">
            <p class="profile-qr__text">{{ copy.TEXT }}</p>
            <p class="profile-qr__hint">{{ copy.BRIGHTNESS_HINT }}</p>

            <div class="profile-qr__actions">
              @if (!confirming()) {
                <app-button #regenerateButton variant="secondary" size="sm" (click)="askRegenerate()">{{
                  copy.REGENERATE
                }}</app-button>
              } @else {
                <p class="profile-qr__confirm">{{ copy.REGENERATE_CONFIRM }}</p>
                <div class="profile-qr__confirm-actions">
                  <button
                    #yesButton
                    type="button"
                    class="profile-qr__yes"
                    [attr.aria-busy]="regenerating() || null"
                    (click)="confirmRegenerate()"
                  >
                    @if (regenerating()) {
                      <app-icon [icon]="spinnerIcon" [size]="16" class="profile-qr__spinner" aria-hidden="true" />
                    }
                    {{ copy.REGENERATE_YES }}
                  </button>
                  <button type="button" class="profile-qr__cancel" (click)="cancelRegenerate()">
                    {{ copy.REGENERATE_CANCEL }}
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
      }
    }

    @case ('clients-only') {
      <!-- `tabindex="-1"`: destino del foco tras un 403 en el regenerado (H3), sin entrar en el orden de tabulación. -->
      <p #clientsOnlyNotice class="profile-qr__notice" tabindex="-1">{{ copy.CLIENTS_ONLY }}</p>
    }

    @case ('error') {
      <div class="profile-qr__error" role="alert">
        <p class="profile-qr__notice">{{ copy.LOAD_ERROR }}</p>
        <app-button variant="secondary" size="sm" (click)="retry()">{{ copy.RETRY }}</app-button>
      </div>
    }
  }

  <p class="profile-qr__live" aria-live="polite">{{ liveMessage() }}</p>
</section>
